import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { IRoomserviceState } from './state'
import { toNumberDictionary, toStringDictionary } from '@/utils/groupBy'
import { buildStateItem } from '@/models/alo/StateItem'
import { CarteDatas } from '@/models/alo/CarteDatas'
import { getDefaultAloAccompagnement } from '@/models/alo/AloAccompagnement'
import { getDefaultAloAllergene } from '@/models/alo/AloAllergene'
import { getDefaultAloBio } from '@/models/alo/AloBio'
import { AloArbo, getDefaultAloArbo } from '@/models/alo/AloArbo'
import { AloPlat, getDefaultAloPlat } from '@/models/alo/AloPlat'
import { getDefaultAloSection } from '@/models/alo/AloSection'
import { IItemPanier, ItemPanier } from '@/models/alo/ItemPanier'
import { getDefaultAloIcon } from '@/models/alo/AloIcon'
import { Crenau } from '@/models/alo/Crenau'
import { AloPanier } from '@/models/alo/AloPanier'




const mutations: MutationTree<IRoomserviceState> = {
    
    [types.ROOM_SERVICES_DATAS_REQUEST]: state => {    
        state.datasStatus = 'Chargement des données du room service'
    },
    [types.ROOM_SERVICES_DATAS_SUCCESS]: (state, datas:CarteDatas) => {            
        state.configuration = {...state.configuration, ...datas.configuration}
        state.iconsDic = {...state.iconsDic, ...toNumberDictionary(datas.icons,i => i.id,getDefaultAloIcon)}                        
        state.allergenesDic = {...state.allergenesDic, ...toNumberDictionary(datas.allergenes,a => a.id,getDefaultAloAllergene)}
        state.biosDic = {...state.biosDic, ...toNumberDictionary(datas.bios,a => a.id,getDefaultAloBio)}
        state.accompagnementsDic = {...state.accompagnementsDic, ...toNumberDictionary(datas.accompagnements,a => a.id,getDefaultAloAccompagnement)}                        
        state.platsDic = {...state.platsDic, ...toNumberDictionary(datas.plats,p => p.id,getDefaultAloPlat)}                        
        state.arbosDic = {...state.arbosDic, ...toNumberDictionary(datas.arbos,a => a.id,getDefaultAloArbo)}     
        state.arbosList = datas.rootArbosIds
        state.sectionsDic = {...state.sectionsDic, ...toNumberDictionary(datas.sections,a => a.id,getDefaultAloSection)}
        state.sectionsList = datas.sections.map(s => s.id)
              
        state.datasStatus = 'Chargement des données du room service terminé'
    },
    [types.ROOM_SERVICES_DATAS_ERROR]: state => {        
        state.datasStatus = 'Erreur lors du chargement des données du room service'
    },
    [types.ROOM_SERVICES_CRENAUX_REQUEST]: state => {    
        state.datasStatus = 'Chargement des crenaux du room service'
    },
    [types.ROOM_SERVICES_CRENAUX_SUCCESS]: (state, datas:Array<Crenau>) => {            
        state.crenaux = datas        
        state.datasStatus = 'Chargement des crenaux du room service terminé'
    },
    [types.ROOM_SERVICES_CRENAUX_ERROR]: state => {        
        state.datasStatus = 'Erreur lors du chargement des crenaux du room service'
    },
    [types.ROOM_SERVICES_PLAT_SET_SELECTION]: (state,{selected,ids}:{selected:boolean,ids:Array<number>}) => {              
        if(ids.length > 1) {
            //on reconstruit comme ca et non en foreach car plus performant sur la reactivité
            state.platsDic = {
                ...state.platsDic,
                ...ids.reduce((dic,id)=> {
                                dic[id] = {...state.platsDic[id],selected}
                                return dic
                        },{} as {[id:number]:AloPlat
                    }) 
            } 
        }
        else if(ids.length == 1) {
            const plat = state.platsDic[ids[0]]
            if(selected && plat.template == 'plat-section') {
                if(state.lastSectionId != -1) state.platsDic[state.lastSectionId].selected = false
                state.lastSectionId = plat.id
            }
            plat.selected = selected
        }
    },
    [types.ROOM_SERVICES_ARBO_SET_SELECTION]: (state,{selected,ids}:{selected:boolean,ids:Array<number>}) => {              
        if(ids.length > 1) {
            //on reconstruit comme ca et non en foreach car plus performant sur la reactivité
            state.arbosDic = {
                ...state.arbosDic,
                ...ids.reduce((dic,id)=> {
                                dic[id] = {...state.arbosDic[id],selected}
                                return dic
                        },{} as {[id:number]:AloArbo
                    }) 
            } 
        }
        else if(ids.length == 1) {
            state.arbosDic[ids[0]].selected = selected
        }
    },    
    [types.ROOM_SERVICES_ADD_PANIER]: (state,item:ItemPanier) => {            
        //recherche dans le panier si un plat avec la meme config a déjà été ajouté          
        const itemPanier = state.panier.items.find(it => it.hasSameConfig(item))
        if(itemPanier) itemPanier.qty++;
        else {
            state.panier.items.push(item)  
            state.panier.updateTime(state.arbosDic)
        }
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))      
    },
    [types.ROOM_SERVICES_UPD_ITEM_COMMENTAIRE]: (state,{uuid,commentaire}:{uuid:string,commentaire:string}) => { 
        state.panier.items.find(it => it.uuid == uuid)!.commentaire = commentaire        
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))
    },
    [types.ROOM_SERVICES_UPD_ITEM_QTY]: (state,{uuid,qty}:{uuid:string,qty:number}) => { 
        if (qty>0) 
            state.panier.items.find(it => it.uuid == uuid)!.qty = qty
        else {
            state.panier.items.splice( state.panier.items.findIndex(it => it.uuid == uuid),1)
            state.panier.updateTime(state.arbosDic)
        }
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))
    },
    [types.ROOM_SERVICES_UPD_HEURE_LIVRAISON]: (state,horaire:string) => { 
        state.panier.heureLivraison = horaire     
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))   
    },
    [types.ROOM_SERVICES_UPD_COMMENTAIRE]: (state,comment:string) => { 
        state.panier.commentaire = comment     
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))   
    },        
    [types.ROOM_SERVICES_UPD_NB_COUVERTS]: (state,nb:number) => { 
        state.panier.nbCouverts = nb        
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))
    },
    
    [types.ROOM_SERVICES_UPD_CONTACT]: (state,contacts:Array<string>) => { 
        state.panier.contacts = contacts      
        if(contacts.length > 0) state.panier.allContacts = false
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))
    },
        
    [types.ROOM_SERVICES_UPD_CART_ITEM]: (state,item:ItemPanier) => { 
        const index = state.panier.items.findIndex(it => it.uuid == item.uuid)
        if(index > -1) state.panier.items.splice(index,1,item)
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))
    },
    [types.ROOM_SERVICES_CLEAR_PANIER]: (state,item:ItemPanier) => { 
        state.panier = new AloPanier()
        localStorage.setItem('tbrs_panier',JSON.stringify(state.panier))
    },        
}

export default mutations